import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitRevListAction extends WorkerAction {
  type: GitAction.RevList;
  params?: string[];
}

export class GitRevListActionError extends WorkerActionError {}

export async function GitRevListActionFn({ lg, params }: WorkerFnParams<GitRevListAction>): Promise<string> {
  try {
    return lg.callAndCaptureOutput(['rev-list', ...(params || [])]);
  } catch (err) {
    throw new GitRevListActionError(err);
  }
}
